import {
	tamarackAPI,
	processApiResponse,
	processApplicationApiResponse,
	processApiCustomResponse,
} from "./Tamarack";

export const ApplicationDataAPI = {
	async fetchApplications(searchObj, brokerId, email) {
		if (searchObj && typeof searchObj !== "object") {
			throw new Error(
				"Search object must be key value type ex: {status: 'Funding'}"
			);
		}
		let searchCriteria = "";
		if (searchObj) {
			let keys = Object.keys(searchObj);
			searchCriteria = `?${keys[0]}=${searchObj[keys[0]]}`;
			for (let i = 1; i < keys.length; i++) {
				searchCriteria = `${searchCriteria}&${keys[i]}=${searchObj[keys[i]]}`;
			}
		}
		const path = `applications${searchCriteria}`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async getClearPersonSearch(requestBody) {
		const path = `clear?type=person`;
		const response = await tamarackAPI.post(path, requestBody);
		return processApiResponse(response, "post", path);
	},
	async getClearBusinessSearch(requestBody) {
		const path = `clear?type=business`;
		const response = await tamarackAPI.post(path, requestBody);
		return processApiResponse(response, "post", path);
	},

	async fetchApplicationById(applicantId, brokerId, email) {
		const path = `application/${applicantId}`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		if (response.status === 404) throw new Error(response.data);
		return processApiResponse(response, "get", path);
	},

	async fetchApplicationGuarantorsById(applicantId, brokerId, email) {
		const path = `application/${applicantId}/guarantors`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async fetchApplicationDocumentsById(applicationId, brokerId, email) {
		const path = `application/${applicationId}/documents`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async fetchApplicationAssetsById(applicantId, brokerId, email) {
		const path = `application/${applicantId}/assets`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async fetchApplicationLocationsById(applicationId, brokerId, email) {
		const path = `application/${applicationId}/locations`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async addNewAssetLocation(locationData) {
		const path = `/location`;
		tamarackAPI.setHeader("broker-id", "ALL");
		const response = await tamarackAPI.post(path, locationData);
		return processApiResponse(response, "post", path);
	},
	async getApplicationFeesById(applicantId, brokerId, email) {
		const path = `application/${applicantId}/fees`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async getApplicationStateSalesTaxById(applicantId, brokerId, email) {
		const path = `application/${applicantId}/stateSalesTaxes`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async fetchApplicationRfisById(applicantId, brokerId, email) {
		const path = `application/${applicantId}/rfis`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async updateApplication(updatedApplication, brokerId, getResponse = false, email) {
		const path = `application`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, updatedApplication);
		if (getResponse) {
			return processApiCustomResponse(response, "put", path);
		}
		return processApiResponse(response, "put", path);
	},
	async DocumentUpload(docsData, applicationInfo, brokerId, email) {
		const documentInfo = {
			application_id: applicationInfo.id, //TODo
			document_name: docsData.file.name,
			type: "sos",
			related_to: "Lessee",
			notes: "Test",
		};
		console.log("Access Api", documentInfo);
		const documentUp = await this.postDocument(documentInfo, brokerId, email)

		console.log("Access documentUp", documentUp);

		const attachmentInfo = {
			name: docsData.file.name,
			parent_id: documentUp,
			body: docsData.baseFile,
			private: false,
		};
		const attachmentId = await this.postAttachment(attachmentInfo, brokerId, email);
		console.log("Attachment Id", attachmentId);
	},

	async postDocument(documentInfo, brokerId, email) {
		const path = `document`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.post(path, documentInfo);
		return processApiResponse(response, "post", path);
	},

	async postAttachment(documentInfo, brokerId, email) {
		const path = `attachment`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.post(path, documentInfo);
		return processApiResponse(response, "post", path);
	},

	async fetchApplicationNotesById(applicantId, brokerId, email) {
		const path = `application/${applicantId}/notes`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},

	async postNote(note, brokerId, email) {
		const path = `note`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.post(path, note);
		return processApiResponse(response, "post", path);
	},
	async deleteNote(noteId) {
		const path = `note/${noteId}`;
		const response = await tamarackAPI.delete(path);
		return processApiResponse(response, "delete", path);
	},
	async updateNote(updatedNote, brokerId, email) {
		const path = `note`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, updatedNote);
		return processApiResponse(response, "put", path);
	},
	async getUsersInfo(applicationId, groupIdCode) {
		const path = `users/${applicationId}?groupId=${groupIdCode}`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async moveAppToAssetReview(app, brokerId, email) {
		const path = `application?action=appmove`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, app);
		return processApiResponse(response, "put", path);
	},
	async transferDeal(app, brokerId, email) {
		const path = `application?action=transferDeal`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, app);
		return processApiResponse(response, "put", path);
	},
	async updateApplicationWithAction(updatedApplication, updateObj, brokerId, email) {
		if (updateObj && typeof updateObj !== "object") {
			throw new Error(
				"Action parameter must be key value type ex: {status: 'Funding'}"
			);
		}
		let updateCriteria = "";
		if (updateObj) {
			let keys = Object.keys(updateObj);
			updateCriteria = `?${keys[0]}=${updateObj[keys[0]]}`;
			for (let i = 1; i < keys.length; i++) {
				updateCriteria = `${updateCriteria}&${keys[i]}=${updateObj[keys[i]]}`;
			}
		}
		const path = `application${updateCriteria}`;
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, updatedApplication);
		return processApplicationApiResponse(response, "put", path);
	},
	async getApplicationStatusCodes() {
		const path = `applicationStatusCodes`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async searchApplications(searchObj, brokerId, email) {		
			const requestData = {
		};	
		Object.keys(searchObj).forEach(key=>{requestData[key]=searchObj[key]});
		tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get("/applications", requestData);
		return processApiResponse(response, "get", "/applications");
	},
	async fetchResubmit(applicationId, email) {
		const path = `/resubmit/${applicationId}`;
		//tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
	async UpdateResubmit(applicationId, data, email) {
		const path = `/resubmit/${applicationId}`;
		//tamarackAPI.setHeader("broker-id", brokerId);
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, data);
		return processApiResponse(response, "put", path);
	},
	async createResubmit(applicationId, email, reason, notes) {
		const updatedApplication = {
			application_id: applicationId,
			status_name: "Resubmit",
			reason: reason,
			notes: notes
		}
		const path = `/update`;
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, updatedApplication);
		return processApplicationApiResponse(response, "put", path);
	},
	async putResubmit(applicationId, email, queue) {
		const updatedApplication = {
			application_id: applicationId,
			status_name: queue,
			locked_by_name: null,
			locked_by_email: null,
			is_locked: false,
		}
		const path = `/update`;
		tamarackAPI.setHeader("email", email);
		const response = await tamarackAPI.put(path, updatedApplication);
		return processApplicationApiResponse(response, "put", path);
	},
};
